<h1 class="h5">Offers</h1>
<div class="card card-body border-0 shadow">
  <button class="btn btn-primary w-100 fw-bold d-block d-lg-none mb-2" type="button" data-bs-toggle="collapse"
    data-bs-target="#filters" aria-expanded="false" aria-controls="filters"><i class="bi bi-funnel"></i> Filters
  </button>

  <form [formGroup]="filters" id="filters" class="collapse filters">
    <div class="row mb-3 g-2">
      <div class="col-lg-2">
        <input formControlName="name" type="text" class="form-control form-control-sm"
          placeholder="Search for offers...">
      </div>

      <div class="col-lg-2">
        <select formControlName="conversionType" class="form-select form-select-sm">
          <option value="">All Payout Type</option>
          @for (conversionType of conversionTypeList; track conversionType) {
            <option
              [value]="conversionType">{{ ('conversionType.' + conversionType) | translate }}
            </option>
          }
        </select>
      </div>

      <div class="col-lg">
        <div class="d-flex">
          <app-dropdown-select placeholder="All verticals" formControlName="verticals" [multiple]="true" class="w-100">
            @for (vertical of verticalList; track vertical) {
              <app-dropdown-select-option [value]="vertical.id">
                {{ ('vertical.' + vertical.identifier) | translate }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-lg-2">
        <select formControlName="requireApproval" class="form-select form-select-sm">
          <option value="">All Statuses</option>
          <option [value]="false">Public</option>
          <option [value]="true">Apply to run</option>
        </select>
      </div>

      <div class="col-lg">
        <div class="d-flex">
          <app-dropdown-select placeholder="🌍 All countries" formControlName="countries" [multiple]="true"
            class="w-100">
            @for (country of countries; track country) {
              <app-dropdown-select-option [value]="country.isoCode">
                {{ country.flagEmoji }} {{ country }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-lg-auto d-flex align-items-center">
        <div class="form-check form-switch">
          <input (change)="fetchAll()" formControlName="active" class="form-check-input" type="checkbox" role="switch"
            id="active">
          <label class="form-check-label" for="active">Active</label>
        </div>
      </div>

      <div class="col-lg-auto">
        <button (click)="fetchAll()" type="submit" class="btn btn-primary btn-sm fw-bold">Submit</button>
      </div>
    </div>
  </form>

  <div class="table-responsive">
    <table class="table table-hover table-striped">
      <thead class="table-light">
        <tr>
          <th width="67">Image</th>
          <th>Offer Name</th>
          <th>Geos</th>
          <th width="96">Payout Type</th>
          <th>Payout</th>
          <th>Custom payout</th>
          <th width="117">Approval</th>
          <th>Vertical</th>
          <th width="64">Status</th>
        </tr>
      </thead>
      <tbody>
        @for (offer of offers; track offer; let i = $index) {
          <tr>
            <td class="align-middle">
              <a [routerLink]="['/offer', offer.id]">
                @if (offer.product?.logo) {
                  <img [src]="imageService.getImageUrl($safeNavigationMigration(offer.product?.logo), 50, 50, false)"
                    class="offers-image" alt="Logo"/>
                }
              </a>
            </td>
            <td class="align-middle"><a [routerLink]="['/offer', offer.id]">{{ offer }}</a></td>
            <td class="align-middle">
              @if (!expandedCountries[i]) {
                @for (country of offer.countries.slice(0, 5); track country) {
                  <span>
                    {{ offer.getCountryEmoji(country) }}
                  </span>
                }
                @if (offer.countries.length > 5) {
                  <span class="text-muted" role="button"
                  (click)="expandedCountries[i] = true">...({{ offer.countries.length }})</span>
                }
              }
              @if (expandedCountries[i]) {
                @for (country of offer.countries; track country) {
                  <span>
                    {{ offer.getCountryEmoji(country) }}
                  </span>
                }
                <i (click)="expandedCountries[i] = false" class="bi bi-eye-slash-fill ms-1 text-muted" role="button"></i>
              }
            </td>
            <td class="align-middle">{{ ('conversionType.' + offer.conversionType) | translate }}</td>
            <td class="align-middle">{{ offer.getRegistrationPayout() | currency: 2:$safeNavigationMigration(offer.currency?.isoCode) }}</td>
            <td class="align-middle">
              @if (getCustomPayout(offer); as customPayout) {
                @if (customPayout.payoutAmount !== null) {
                  <span
                  class="fw-bold">{{ customPayout.payoutAmount | currency: 2:$safeNavigationMigration(customPayout.currency?.isoCode) }}</span>
                }
                @if (customPayout.payoutAmount === null && customPayout.payoutPercent !== null) {
                  <span
                  class="fw-bold">{{ customPayout.payoutPercent }} %</span>
                }
              }
            </td>
            <td class="align-middle">
              <span [ngClass]="getOfferStatusClass(offer)"
              class="badge">{{ ('partnerOfferStatus.' + getOfferStatus(offer)) | translate }}</span>
            </td>
            <td class="align-middle">
              @if (offer?.verticals) {
                @for (vertical of offer?.verticals; track vertical; let last = $last) {
                  {{ getVerticalName(vertical) | translate }}
                  @if (!last) {
                    /
                  }
                }
              }
            </td>
            <td class="align-middle text-center">
              <i class="bi bi-circle-fill"
                [ngClass]="isUsedOffer(offer) ? 'text-success' : 'text-secondary opacity-25'"
              [title]="isUsedOffer(offer) ? 'You already got conversions on this offer' : 'No conversion on this offer yet'"></i>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
</div>
